import { Badge } from "@chakra-ui/react";
import { ReactNode } from "react";
import { EngagementMode } from "../views/R2DOrders/types";

interface EngagementModeBadgeProps {
  engagementMode: string;
  size?: "sm" | "md" | "lg";
  children?: ReactNode;
  ml?: number | string;
}

export default function EngagementModeBadge({ 
  engagementMode, 
  size = "sm",
  children,
  ml
}: EngagementModeBadgeProps) {
  return (
    <Badge
      ml={ml}
      backgroundColor={`${
        engagementMode === EngagementMode.PLATFORM
          ? "white"
          : engagementMode === EngagementMode.EXPIRED
          ? "red.500"
          : "#FFD601"
      }`}
      outline={
        engagementMode === EngagementMode.PLATFORM
          ? "1px solid #FFD601"
          : "none"
      }
      fontSize="xx-small"
      height="fit-content"
      color={
        engagementMode === EngagementMode.EXPIRED
          ? "white"
          : "black"
      }
      px={3}
      py={0.5}
      borderRadius="full"
    >
      {children || engagementMode}
    </Badge>
  );
} 